import {
  DocumentTextIcon,
  ScaleIcon,
  HandRaisedIcon,
} from "@heroicons/react/24/outline";

import { Resumo } from "./tabs/resumo";
import { Dispositivos } from "./tabs/dispositivos";
import { Riscos } from "./tabs/riscos";
import { NoticeItem } from "./notice.types";

export const noticeItems = [
  {
    id: "resumo",
    label: "Resumo",
    description: "Saiba tudo sobre o edital do leilão de imóveis",
    icon: DocumentTextIcon,
    content: (props: NoticeItem) => <Resumo {...props} />,
  },
  {
    id: "dispositivos",
    label: "Dispositivos",
    description: "Entenda a interpretação dos dispositivos do edital",
    icon: ScaleIcon,
    content: (props: NoticeItem) => <Dispositivos {...props} />,
  },
  {
    id: "riscos",
    label: "Riscos",
    description: "Encontre os riscos e pontos críticos do edital",
    icon: HandRaisedIcon,
    content: (props: NoticeItem) => <Riscos {...props} />,
  },
];
